import React from 'react';
import { Row, Col } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

import Defect from './Defect';
import { AddsContainer } from './common';

function DefectsContainer({
  itemKey,
  defects,
  addSubItem,
  deleteSubItem,
  changeSubItem,
  changeItemProperty,
}) {
  return (
    <Row style={{ margin: '10px' }} gutter={16}>
      <Col span={24}>
        <AddsContainer>
          <Row type="flex" align="middle">
            <Col style={{ width: 40, textAlign: 'center' }}>
              <InfoCircleOutlined style={{ fontSize: '32px' }} />
            </Col>
            <Col style={{ flex: 1, paddingLeft: 5 }}>
              <Row>
                <Col span={23} style={{ borderBottom: '1px solid #d9d9d9' }}>
                  DVIR Defects:
                </Col>
                <Col span={1}></Col>
              </Row>
              <Defect
                defects={defects}
                itemKey={itemKey}
                deleteSubItem={() => deleteSubItem(itemKey, 'defects')}
                changeItemProperty={changeItemProperty}
              />
            </Col>
          </Row>
        </AddsContainer>
      </Col>
    </Row>
  );
}

export default DefectsContainer;
